/* @flow */

import * as Schema from '../schema';

export function fetchSchema() {
    return Schema.fetchSchema('leads/list/fields');
}
